import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as image from "../../resources/images";
import { PATHS } from "../../utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const DashBoardEmptyPopUp = ({ closePopup }) => {
    const history = useHistory();
     const { 
            defaultChildData,
        } = useSelector( (state) => state.collections );
    const handleRedirect = () => {
         history.push({
                    pathname: PATHS.COURSE_CATLOG_STR + defaultChildData?.id,
                    // state: {}
         })
        closePopup();
    }
    return (
             <div className="smallpopup ">
                    <div className="modal d-flex" id="schoolactivity10" role="dialog">
                      <div className="modal-dialog modal-lg">
                        <div className="modal-content my_popup">
                         
                          <div className="modal-body paymentinfo p-0">
                           <div className="defaultDashboardpopup text-center" >
                            <img src={image.dashboardpopup} alt="defaultpopup" />
                            <h3 className="mt-3 mb-2">So Empty Around Here</h3>
                            <p className="p2 lighttextcolor">Enroll in a course to view your dashboard</p>
                           </div>
                       </div>
                     
                        
                          <div className="modal-footer justify-content-center">
                          <div className="text-center mt-3 pt-3">
                                  <button
                                    type="button"
                                    className="mybutton"
                                    onClick={()=>handleRedirect()}
                                  >
                                     Go To Course Catalog
                                  </button>
                             </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
        )
}
export default DashBoardEmptyPopUp;